import React from 'react'
import { FormattedMessage } from 'react-intl'

import { ArticleThumbnail } from '../../article-thumbnail/article-thumbnail'
import { Carousel } from '../../../../organisms/carousel'
import Container from '../../../container/Container'

type SimilarArticlesProps = {
  articles: Parameters<typeof ArticleThumbnail>[0]['article'][]
}

export const SimilarArticles = ({ articles }: SimilarArticlesProps) => {
  if (articles.length === 0) {
    return null
  }

  return (
    <Container
      title={{
        label: (
          <FormattedMessage
            id='ui.SimilarArticle.bannerTitle'
            defaultMessage='Explorez le magazine'
          />
        ),
        align: 'left',
      }}
      dataGtm='blog'
    >
      <Carousel
        arrowsDataGtm='blog'
        scrollAllVisibleSlides={false}
        className='-mx-2 pt-4'
        responsive={{
          0: { items: 1 },
          420: { items: 2 },
          700: { items: 3 },
          1000: { items: 4 },
        }}
        items={articles.map((article) => (
          <ArticleThumbnail
            key={article.id}
            article={article}
            className='px-2'
          />
        ))}
        defaultNbItems={2}
      />
    </Container>
  )
}
